import Axios from "axios"

export const classNames = ( ...classes ) => {
    return classes.filter( Boolean ).join( "" )
}

export const truncate = ( str, n ) => ( str.length > n ) ? str.substr( 0, n - 1 ) + '...' : str

export const formatFullName = ( firstname, middlename, lastname ) => {
    if( typeof middlename !== "undefined" && middlename ) {
        return firstname?.toUpperCase() + " " + middlename?.toUpperCase() + " "  + lastname?.toUpperCase()
    }
    return firstname?.toUpperCase() + " " + lastname?.toUpperCase()
    
}

export const formatPhoneNumber = phone => {
    // if( phone ) {
    //     return phone.split( " " ).join( "" )
    // }
    // console.log( phone ) 
}

export const fetchTraveller = async ( email, successCallback, errorCallback ) => {
    try {
        const response = await Axios.get( `http://health.caa.works.go.ug/api/v1/traveller` )
        if( response.data ){
            const results = response.data.filter( record => record.email === email )
            if( results.length > 0 ) {
                successCallback( results )
            }
            else {
                successCallback( results )
            }
        }

    } catch( error ){
        errorCallback( error )
    }
}

export const capitalize = str => {
    if( str ) { 
        return str.slice( 0 , 1 )?.toUpperCase() + "" + str.slice( 1 )?.toLowerCase()
    }
    return str
}

export const formatCurrency = ( amount, tag = true ) => {
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: "UGX",
    } );
    return formatter.format( amount );
}

export const formatValues = value => {
    return value.toLocaleString( "en-US" )
}

export const onlyUnique = ( elements ) => {
    return elements.filter( ( value, index, self ) => {
        return self.indexOf( value ) === index
    } )
}

export const createHHNumber = ( args ) => {
    let code = ""
    const { district, subcounty, parish, county, village, town } = args
    if( district && district?.length > 0 ) {
       code += district.slice( 0, 2 )?.toUpperCase()
    }

    if( subcounty && subcounty?.length > 0 ) {
        code += "-" + subcounty.slice( 0, 2 )?.toUpperCase()
    }

    if( county && county?.length > 0 ) {
        code += "-" + county.slice( 0, 2 )?.toUpperCase()
    }

    if( village && village?.length > 0 ) {
        code += "-" + village.slice( 0, 2 )?.toUpperCase()
    }

    if( parish && parish?.length > 0 ) {
        code += "-" + parish.slice( 0, 2 )?.toUpperCase()
    }

    if( town && town?.length > 0 ) {
        code += "-" + town.slice( 0, 2 )?.toUpperCase()
    }

    return code
}

export const getMaxFarmerId = async ( callback ) => {
    try {
        const response = await Axios.get( `https://mis.nec.go.ug/api/auth/fiefoc_maxId/${localStorage.getItem( "scheme" )}` )
        if( response.data ) {
            callback( response.data?.records )
        }
    } catch (error) {
        
    }
}

export const generateSchemeCode = () => {
    switch( localStorage.getItem( "scheme" ) ) {
        case "Doho_II":
            return "DIS"
        case "Tochi":
            return "TIS"
        case "Mobuku_II":
            return "MIS"
        case "Ngenge":
            return "NIS"
        default:
            return null
    }
}

export const getDefaultDistrict = () => {
    switch( localStorage.getItem( "scheme" ) ) {
        case "Doho_II":
            return "Butaleja"
        case "Tochi":
            return "Oyam"
        case "Mobuku_II":
            return "Kasese"
        case "Ngenge":
            return "Kween"
        case "Wadelai":
            return "Pakwach"
        default:
            return null
    }
}

// export const 